import type { ReplyReviewReason } from "@/features/ai-agent/types/reply-review";

/** Fixed reasons a reply can be rated down or discarded for, in picker order. */
export const REPLY_REVIEW_REASONS: ReplyReviewReason[] = [
  "too_long",
  "too_short",
  "wrong_facts",
  "wrong_tone",
  "missed_question",
  "should_have_escalated",
  "unsafe",
  "not_needed",
  "other",
];

/** The reasons a thumbs-down offers as one-tap chips before the full form.
 *  Three is what fits on one line under a bubble with the question and
 *  "More…"; the rest sit behind it. */
export const REPLY_QUICK_REASONS: ReplyReviewReason[] = [
  "too_long",
  "wrong_facts",
  "wrong_tone",
];

/** The same for a reply rated up. Kept apart from the negative list: "right
 *  length" and "too long" are different observations, not one scale. */
export const REPLY_UP_REASONS: ReplyReviewReason[] = [
  "good_tone",
  "right_length",
  "answered_fully",
  "good_next_step",
  "other",
];

export const REPLY_REVIEW_REASON_LABEL: Record<ReplyReviewReason, string> = {
  too_long: "Too long",
  too_short: "Too short",
  wrong_facts: "Wrong or made-up facts",
  wrong_tone: "Wrong tone",
  missed_question: "Missed the question",
  should_have_escalated: "Should have handed over",
  unsafe: "Unsafe or against policy",
  not_needed: "Not needed",
  other: "Something else",
  good_tone: "Right tone",
  right_length: "Right length",
  answered_fully: "Answered fully",
  good_next_step: "Good next step",
};

/** Chip labels for the quick reasons: the full labels, shortened where one
 *  runs long for a chip. */
export const REPLY_QUICK_REASON_LABEL: Record<ReplyReviewReason, string> = {
  ...REPLY_REVIEW_REASON_LABEL,
  wrong_facts: "Wrong facts",
};

/** The reasons Discard offers on the Echo line, one tap each; "other" is the
 *  catch-all, and discarding without a reason stays one tap too. */
export const DISCARD_QUICK_REASONS: ReplyReviewReason[] = [
  "wrong_facts",
  "wrong_tone",
  "not_needed",
  "other",
];
